import React, { Component } from 'react'
import Included from '../Included'
import DarkThemeNav from '../common/dark-theme-nav';
class Pagination extends Component {

  constructor(props) {
    super(props)
  }

  render (){
    return(
    <section><a className="anchor"id="pagination"></a>
    <h2>Pagination</h2>

    <DarkThemeNav anchor="pagination" />

    <p>Include the comment blocks to strip whitespace around the text and keep the styling consistent</p>

    <select className="size-select">
      <option value="">Select a resolution</option>
      <option value="482">480px (xs)</option>
      <option value="770">768px (sm)</option>
      <option value="994">992px (md)</option>
      <option value="1202">1200px (lg)</option>
    </select>
    <br/><br/>
      <div className="iframe-container" style={{"height":"100px"}}>
        <iframe seamless srcDoc={`
        <html data-theme="default">
          <head>
            <link rel="stylesheet" type="text/css" href="css/commonUI.css">
            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
          </head>
          <body>
          <div class="grid">
            <div class="grid__col-12 grid--direction-row grid--justify-center display--block">
            <ol class="pagination js-pagination"><!--
        --><li class="pagination__first"><i class="fa fa-angle-double-left"></i></li><!--
        --><li class="pagination__prev"><i class="fa fa-angle-left"></i>Prev</li><!--
        --><li class="pagination__current">1 of 10</li><!--
        --><li><a href="javascript:;">2</a></li><!--
        --><li><a href="javascript:;">3</a></li><!--
        --><li><a href="javascript:;">4</a></li><!--
        --><li><a href="javascript:;">5</a></li><!--
        --><li><a href="javascript:;">6</a></li><!--
        --><li><a href="javascript:;">7</a></li><!--
        --><li><a href="javascript:;">8</a></li><!--
        --><li><a href="javascript:;">9</a></li><!--
        --><li><a href="javascript:;">10</a></li><!--
        --><li class="pagination__next"><a href="javascript:;">Next<i class="fa fa-angle-right"></i></a></li><!--
        --><li class="pagination__last"><a href="javascript:;"><i class="fa fa-angle-double-right"></i></a></li><!--
        --></ol>
          </div>
          </div>
          </body>
          <script type="text/javascript" src="js/commonUI.js"></script>
          <script>
            function init() {
              commonUI.initializePagination();
            }
            window.onload = init;
          </script>
        </html>
      `}></iframe>
    </div>

    <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
    <pre className="hide-code"><code className="language-html">{`<ol class="pagination js-pagination"><!--
--><li class="pagination__first"><i class="fa fa-angle-double-left"></i></li><!--
--><li class="pagination__prev"><i class="fa fa-angle-left"></i>Prev</li><!--
--><li class="pagination__current">1 of 10</li><!--
--><li><a href="#">2</a></li><!--
--><li><a href="#">3</a></li><!--
--><li><a href="#">4</a></li><!--
--><li><a href="#">5</a></li><!--
--><li><a href="#">6</a></li><!--
--><li><a href="#">7</a></li><!--
--><li><a href="#">8</a></li><!--
--><li><a href="#">9</a></li><!--
--><li><a href="#">10</a></li><!--
--><li class="pagination__next"><a href="#">Next<i class="fa fa-angle-right"></i></a></li><!--
--><li class="pagination__last"><a href="#"><i class="fa fa-angle-double-right"></i></a></li><!--
--></ol>`}</code></pre>
     <br/>

       <select className="size-select">
         <option value="">Select a resolution</option>
         <option value="482">480px (xs)</option>
         <option value="770">768px (sm)</option>
         <option value="994">992px (md)</option>
         <option value="1202">1200px (lg)</option>
       </select>
       <br/><br/>
       <div className="iframe-container" style={{"height":"100px"}}>
         <iframe seamless srcDoc={`
         <html data-theme="default">
           <head>
             <link rel="stylesheet" type="text/css" href="css/commonUI.css">
             <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
             <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
           </head>
           <body>
           <div class="grid">
             <div class="grid__col-12 grid--direction-row grid--justify-center display--block">
               <ol class="pagination js-pagination"><!--
             --><li class="pagination__first"><a href="javascript:;"><i class="fa fa-angle-double-left"></i></a></li><!--
             --><li class="pagination__prev"><a href="javascript:;"><i class="fa fa-angle-left"></i>Prev</a></li><!--
             --><li><a href="javascript:;">1</a></li><!--
             --><li><a href="javascript:;">2</a></li><!--
             --><li class="pagination__current">3 of 10</li><!--
             --><li><a href="javascript:;">4</a></li><!--
             --><li><a href="javascript:;">5</a></li><!--
             --><li><a href="javascript:;">6</a></li><!--
             --><li><a href="javascript:;">7</a></li><!--
             --><li><a href="javascript:;">8</a></li><!--
             --><li><a href="javascript:;">9</a></li><!--
             --><li><a href="javascript:;">10</a></li><!--
             --><li class="pagination__next"><a href="javascript:;">Next<i class="fa fa-angle-right"></i></a></li><!--
             --><li class="pagination__last"><a href="javascript:;"><i class="fa fa-angle-double-right"></i></a></li><!--
           --></ol>
             </div>
           </div>
           </body>
           <script type="text/javascript" src="js/commonUI.js"></script>
           <script>
             function init() {
               commonUI.initializePagination();
             }
             window.onload = init;
           </script>
         </html>
       `}></iframe>
   </div>

   <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
   <pre className="hide-code"><code className="language-html">{`<ol class="pagination js-pagination"><!--
  --><li class="pagination__first"><a href="#"><i class="fa fa-angle-double-left"></i></a></li><!--
  --><li class="pagination__prev"><a href="#"><i class="fa fa-angle-left"></i>Prev</a></li><!--
  --><li><a href="#">1</a></li><!--
  --><li><a href="#">2</a></li><!--
  --><li class="pagination__current">3 of 10</li><!--
  --><li><a href="#">4</a></li><!--
  --><li><a href="#">5</a></li><!--
  --><li><a href="#">6</a></li><!--
  --><li><a href="#">7</a></li><!--
  --><li><a href="#">8</a></li><!--
  --><li><a href="#">9</a></li><!--
  --><li><a href="#">10</a></li><!--
  --><li class="pagination__next"><a href="#">Next<i class="fa fa-angle-right"></i></a></li><!--
  --><li class="pagination__last"><a href="#"><i class="fa fa-angle-double-right"></i></a></li><!--
--></ol>`}</code></pre>
     <br/>

     <br/>

     <p>Applying classes of <code>pagination--lite</code> or <code>pagination--small</code> will affect the look and feel of pagination in the following ways</p>

    <h4>Pagination Lite</h4>
    <p><code>pagination--lite</code> class applied</p>

     <select className="size-select">
         <option value="">Select a resolution</option>
         <option value="482">480px (xs)</option>
         <option value="770">768px (sm)</option>
         <option value="994">992px (md)</option>
         <option value="1202">1200px (lg)</option>
       </select>
       <br/><br/>
       <div className="iframe-container" style={{"height":"100px"}}>
         <iframe seamless srcDoc={`
         <html data-theme="default">
           <head>
             <link rel="stylesheet" type="text/css" href="css/commonUI.css">
             <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
             <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
           </head>
           <body>
           <div class="grid">
             <div class="grid__col-12 grid--direction-row grid--justify-center display--block">
               <ol class="pagination pagination--lite js-pagination"><!--
             --><li class="pagination__first"><a href="javascript:;"><i class="fa fa-angle-double-left"></i></a></li><!--
             --><li class="pagination__prev"><a href="javascript:;"><i class="fa fa-angle-left"></i>Prev</a></li><!--
             --><li><a href="javascript:;">1</a></li><!--
             --><li><a href="javascript:;">2</a></li><!--
             --><li class="pagination__current">3 of 10</li><!--
             --><li><a href="javascript:;">4</a></li><!--
             --><li><a href="javascript:;">5</a></li><!--
             --><li><a href="javascript:;">6</a></li><!--
             --><li><a href="javascript:;">7</a></li><!--
             --><li><a href="javascript:;">8</a></li><!--
             --><li><a href="javascript:;">9</a></li><!--
             --><li><a href="javascript:;">10</a></li><!--
             --><li class="pagination__next"><a href="javascript:;">Next<i class="fa fa-angle-right"></i></a></li><!--
             --><li class="pagination__last"><a href="javascript:;"><i class="fa fa-angle-double-right"></i></a></li><!--
           --></ol>
             </div>
           </div>
           </body>
           <script type="text/javascript" src="js/commonUI.js"></script>
           <script>
             function init() {
               commonUI.initializePagination();
             }
             window.onload = init;
           </script>
         </html>
       `}></iframe>
   </div>

  <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
  <pre className="hide-code"><code className="language-html">{`<ol class="pagination pagination--lite js-pagination"><!--
  --><li class="pagination__first"><a href="#"><i class="fa fa-angle-double-left"></i></a></li><!--
  --><li class="pagination__prev"><a href="#"><i class="fa fa-angle-left"></i>Prev</a></li><!--
  --><li><a href="#">1</a></li><!--
  --><li><a href="#">2</a></li><!--
  --><li class="pagination__current">3 of 10</li><!--
  --><li><a href="#">4</a></li><!--
  --><li><a href="#">5</a></li><!--
  --><li><a href="#">6</a></li><!--
  --><li><a href="#">7</a></li><!--
  --><li><a href="#">8</a></li><!--
  --><li><a href="#">9</a></li><!--
  --><li><a href="#">10</a></li><!--
  --><li class="pagination__next"><a href="#">Next<i class="fa fa-angle-right"></i></a></li><!--
  --><li class="pagination__last"><a href="#"><i class="fa fa-angle-double-right"></i></a></li><!--
--></ol>`}</code></pre>

<h4>Pagination Small</h4>
<p><code>pagination--small</code> class applied</p>

<select className="size-select">
         <option value="">Select a resolution</option>
         <option value="482">480px (xs)</option>
         <option value="770">768px (sm)</option>
         <option value="994">992px (md)</option>
         <option value="1202">1200px (lg)</option>
       </select>
       <br/><br/>
       <div className="iframe-container" style={{"height":"100px"}}>
         <iframe seamless srcDoc={`
         <html data-theme="default">
           <head>
             <link rel="stylesheet" type="text/css" href="css/commonUI.css">
             <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
             <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
           </head>
           <body>
           <div class="grid">
             <div class="grid__col-12 grid--direction-row grid--justify-center display--block">
               <ol class="pagination pagination--small js-pagination"><!--
             --><li class="pagination__first"><a href="javascript:;"><i class="fa fa-angle-double-left"></i></a></li><!--
             --><li class="pagination__prev"><a href="javascript:;"><i class="fa fa-angle-left"></i>Prev</a></li><!--
             --><li><a href="javascript:;">1</a></li><!--
             --><li><a href="javascript:;">2</a></li><!--
             --><li class="pagination__current">3 of 10</li><!--
             --><li><a href="javascript:;">4</a></li><!--
             --><li><a href="javascript:;">5</a></li><!--
             --><li><a href="javascript:;">6</a></li><!--
             --><li><a href="javascript:;">7</a></li><!--
             --><li><a href="javascript:;">8</a></li><!--
             --><li><a href="javascript:;">9</a></li><!--
             --><li><a href="javascript:;">10</a></li><!--
             --><li class="pagination__next"><a href="javascript:;">Next<i class="fa fa-angle-right"></i></a></li><!--
             --><li class="pagination__last"><a href="javascript:;"><i class="fa fa-angle-double-right"></i></a></li><!--
           --></ol>
             </div>
           </div>
           </body>
           <script type="text/javascript" src="js/commonUI.js"></script>
           <script>
             function init() {
               commonUI.initializePagination();
             }
             window.onload = init;
           </script>
         </html>
       `}></iframe>
   </div>

  <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
  <pre className="hide-code"><code className="language-html">{`<ol class="pagination pagination--small js-pagination"><!--
  --><li class="pagination__first"><a href="#"><i class="fa fa-angle-double-left"></i></a></li><!--
  --><li class="pagination__prev"><a href="#"><i class="fa fa-angle-left"></i>Prev</a></li><!--
  --><li><a href="#">1</a></li><!--
  --><li><a href="#">2</a></li><!--
  --><li class="pagination__current">3 of 10</li><!--
  --><li><a href="#">4</a></li><!--
  --><li><a href="#">5</a></li><!--
  --><li><a href="#">6</a></li><!--
  --><li><a href="#">7</a></li><!--
  --><li><a href="#">8</a></li><!--
  --><li><a href="#">9</a></li><!--
  --><li><a href="#">10</a></li><!--
  --><li class="pagination__next"><a href="#">Next<i class="fa fa-angle-right"></i></a></li><!--
  --><li class="pagination__last"><a href="#"><i class="fa fa-angle-double-right"></i></a></li><!--
--></ol>`}</code></pre>

    <br/>
    <br/>

    <h4>Pagination Small and Pagination Lite</h4>
<p><code>pagination--small pagination-lite</code> classes applied</p>

<select className="size-select">
         <option value="">Select a resolution</option>
         <option value="482">480px (xs)</option>
         <option value="770">768px (sm)</option>
         <option value="994">992px (md)</option>
         <option value="1202">1200px (lg)</option>
       </select>
       <br/><br/>
       <div className="iframe-container" style={{"height":"100px"}}>
         <iframe seamless srcDoc={`
         <html data-theme="default">
           <head>
             <link rel="stylesheet" type="text/css" href="css/commonUI.css">
             <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
             <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
           </head>
           <body>
           <div class="grid">
             <div class="grid__col-12 grid--direction-row grid--justify-center display--block">
               <ol class="pagination pagination--small pagination--lite js-pagination"><!--
             --><li class="pagination__first"><a href="javascript:;"><i class="fa fa-angle-double-left"></i></a></li><!--
             --><li class="pagination__prev"><a href="javascript:;"><i class="fa fa-angle-left"></i>Prev</a></li><!--
             --><li><a href="javascript:;">1</a></li><!--
             --><li><a href="javascript:;">2</a></li><!--
             --><li class="pagination__current">3 of 10</li><!--
             --><li><a href="javascript:;">4</a></li><!--
             --><li><a href="javascript:;">5</a></li><!--
             --><li><a href="javascript:;">6</a></li><!--
             --><li><a href="javascript:;">7</a></li><!--
             --><li><a href="javascript:;">8</a></li><!--
             --><li><a href="javascript:;">9</a></li><!--
             --><li><a href="javascript:;">10</a></li><!--
             --><li class="pagination__next"><a href="javascript:;">Next<i class="fa fa-angle-right"></i></a></li><!--
             --><li class="pagination__last"><a href="javascript:;"><i class="fa fa-angle-double-right"></i></a></li><!--
           --></ol>
             </div>
           </div>
           </body>
           <script type="text/javascript" src="js/commonUI.js"></script>
           <script>
             function init() {
               commonUI.initializePagination();
             }
             window.onload = init;
           </script>
         </html>
       `}></iframe>
   </div>

  <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
  <pre className="hide-code"><code className="language-html">{`<ol class="pagination pagination--small pagination--lite js-pagination"><!--
  --><li class="pagination__first"><a href="#"><i class="fa fa-angle-double-left"></i></a></li><!--
  --><li class="pagination__prev"><a href="#"><i class="fa fa-angle-left"></i>Prev</a></li><!--
  --><li><a href="#">1</a></li><!--
  --><li><a href="#">2</a></li><!--
  --><li class="pagination__current">3 of 10</li><!--
  --><li><a href="#">4</a></li><!--
  --><li><a href="#">5</a></li><!--
  --><li><a href="#">6</a></li><!--
  --><li><a href="#">7</a></li><!--
  --><li><a href="#">8</a></li><!--
  --><li><a href="#">9</a></li><!--
  --><li><a href="#">10</a></li><!--
  --><li class="pagination__next"><a href="#">Next<i class="fa fa-angle-right"></i></a></li><!--
  --><li class="pagination__last"><a href="#"><i class="fa fa-angle-double-right"></i></a></li><!--
--></ol>`}</code></pre>

    <br/>
    <br/>

     <p>This is a partly javascript enabled component. You need to use the classes shown above to enable the responsive pagination</p>
     <p><b>Responsive functionality is only available with javascript</b></p>

     <pre><code className="language-javascript">{`// Using default classes shown in snippet.
// The library looks for the class 'js-pagination' by default.
commonUI.initializePagination();

// You can have multiple paginations on the page, they will all be initialised

// Using custom selectors
commonUI.initializePagination({selector:'.special-pagination'});`}</code></pre>
    <hr />
    </section>
  )
}
}

export default Pagination



// WEBPACK FOOTER //
// ./styleguide/components/sections/Pagination.js